import React, { useState, useEffect } from "react";
import ReactDOM from 'react-dom';
import { config } from "../../../config/config";
import { useForm } from "react-hook-form";


const Footer = () => {
  /* smoot scroll */
  let handleSmoothScroll = (e, targetId) => {
    e.preventDefault();
    const target = document.querySelector(targetId);
    if (target) {
      let top_space = 0;
      const header = document.getElementById("header");
      if (header) {
        top_space = header.offsetHeight;
        if (!header.classList.contains("header-scrolled")) {
          top_space -= 20;
        }
      }
      window.scroll({
        top: target.offsetTop - top_space,
        behavior: "smooth",
      });
    }
  };
  /* end */

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {

    const fixData = {
      "name": "Anonymous",
      "email": "guest@microvisioninfotech.com",
      "message": "Shared Phone Number"
    }
    // perform async request, for example, using fetch
    const response = await fetch(config.env.mvitVantageEmailService, {
      method: "POST",
      body: JSON.stringify({ ...fixData, ...data }),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        // // // check if response is successful
        if (response.ok) {
          alert("Thanks");
        }
      })
      .then((data) => {
        //for now no use response data
      })
      .catch((error) => {
        // handle network errors or other exceptions
        console.error(
          "An error occurred in share mobile number :",
          error.message
        );
      });
  };



  return (
    <>
      {/* ==========================
    Footer
  ============================ */}
      <div id="footer">
        <div className="footer-top">
          <div className="container">
            <div className="row">
              <div className="col-lg-4 col-md-6 footer-info">
                <h3>Microvision Infotech</h3>
                <p>
                  Your premier destination for cutting-edge digital solutions.
                  With over 30 years of industry experience in web development
                  and design, we're pioneers in crafting bespoke online training
                  courses for IT technologies. Our seasoned team blends
                  innovation with expertise, ensuring every project exceeds
                  expectations. Trust Microvision Infotech to elevate your
                  digital presence and empower your workforce with our
                  comprehensive solutions.
                </p>
              </div>

              <div className="col-lg-2 col-md-6 footer-links">
                <h4>Useful Links</h4>
                <ul>
                  <li key="l1">
                    <a
                      href="#intro"
                      onClick={(e) => handleSmoothScroll(e, "#intro")}
                    >
                      Home
                    </a>
                  </li>
                  <li key="l_expertise">
                    <a
                      href="#expertise"
                      onClick={(e) => handleSmoothScroll(e, "#expertise")}
                    >
                      Expertise
                    </a>
                  </li>
                  <li key="l2">
                    <a
                      href="#about"
                      onClick={(e) => handleSmoothScroll(e, "#about")}
                    >
                      About us
                    </a>
                  </li>
                  <li key="l3">
                    <a
                      href="#services"
                      onClick={(e) => handleSmoothScroll(e, "#services")}
                    >
                      Services
                    </a>
                  </li>
                  <li key="l_products">
                    <a
                      href="#products"
                      onClick={(e) => handleSmoothScroll(e, "#products")}
                    >
                      Products
                    </a>
                  </li>
                  <li key="l_team">
                    <a
                      href="#team"
                      onClick={(e) => handleSmoothScroll(e, "#team")}
                    >
                      Our Team
                    </a>
                  </li>
                  <li key="l4">
                    <a
                      href="#portfolio"
                      onClick={(e) => handleSmoothScroll(e, "#portfolio")}
                    >
                      Portfolio
                    </a>
                  </li>
                  <li key="l5">
                    <a
                      href="#contact"
                      onClick={(e) => handleSmoothScroll(e, "#contact")}
                    >
                      Contact Us
                    </a>
                  </li>
                </ul>
              </div>

              <div className="col-lg-6 col-md-6 footer-contact">
                <h4>Contact Us</h4>
                <p>
                  88, Sector I <br />
                  Green Park Colony
                  <br />
                  Indore, Madhya Pradesh <br /> INDIA - 452002
                  <br />
                  <strong>Phone:</strong> +91 831-920-3408, +91 94797-16489, +91 98275-82762
                  <br />
                  <strong>Email:</strong> contact@microvisioninfotech.com
                  <br />
                </p>

                {/* <div className="social-links">
                  <a href="#" className="twitter">
                    <i className="fa fa-twitter"></i>
                  </a>
                  <a href="#" className="facebook">
                    <i className="fa fa-facebook"></i>
                  </a>
                  <a href="#" className="instagram">
                    <i className="fa fa-instagram"></i>
                  </a>
                  <a href="#" className="google-plus">
                    <i className="fa fa-google-plus"></i>
                  </a>
                  <a href="#" className="linkedin">
                    <i className="fa fa-linkedin"></i>
                  </a>
                </div> */}
                <br />
                <h4>Share your mobile number with us for contacting you.</h4>
                <form
                  action=""
                  method="post"
                  role="form"
                  onSubmit={handleSubmit(onSubmit)}
                >
                  <input
                    type="hidden"
                    name="to"
                    value={config.env.contactTo}
                    {...register("to")}
                  />
                  <input
                    type="hidden"
                    name="email_requester"
                    value={config.env.currentDomain}
                    {...register("email_requester")}
                  />
                  <input
                    type="phone"
                    name="phone"
                    style={{ maxWidth: "150px" }}
                    {...register("phone")}
                  />
                  <input
                    type="submit"
                    value="Contact to me"
                    style={{ padding: "1px", width: "100px" }}
                  />
                </form>
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="copyright">
            &copy; Copyright 1996 - {new Date().getFullYear()} <strong>Microvision Infotech</strong>. All Rights
            Reserved.
          </div>
        </div>
      </div>
      {/* #footer */}
    </>
  );
};

export default Footer;